import * as angular from 'angular';
import {IController, IIntervalService, IQService, ITimeoutService} from 'angular';
import * as _ from "lodash";
import {AgentsService} from "../../services/agents-service.service";
import {AgentModel} from "../../angular/models/agent.model";
import {ServiceAreasService} from "../../../service-areas/services/service-areas-service.service";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {$agentsFactory} from "../../$agents.factory";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {ServicesService} from "../../../deliveries/services/services-service.service";
import {LeanPlanningAlertsService} from "../../../lean-planning/services/lean-planning-alerts.factory";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ScheduleDialogService} from "../../../schedule/services/schedule-dialog.service";
import {ScheduleService} from "../../../schedule/services/schedule-service.service";
import {AgentsPaginationQueryModel} from "../../angular/models/agents-pagination-query.model";
import {AgentsPaginationDataModel} from "../../angular/models/agents-pagination-data.model";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {AgentsContextService} from "../../services/agents-context.service";
import {ScheduleType} from "../../../schedule/types/schedule.type";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";
import {EmploymentType} from "../../types/employment.type";
import {AgentScheduleExtraDataRequestType} from "../../../schedule/types/agent-schedule-extra-data-request.type";
import {AgentScheduleExtraDataRequestModel} from "../../../schedule/models/agent-schedule-extra-data-request.model";
import {BranchModel} from "../../../branches/models/branch.model";
import {AbsenceReasonSettings} from "../../../site-preferences/models/absence-reason-settings.model";

export class AgentsShiftManagementViewNewComponent implements IController {

  agentsGroup: any;
  from: any;
  to: any;
  size: number;
  page: number;
  branchIds?: string;
  agentIds?: string[];
  teamIds?: string[];
  serviceAreaIds?: any;
  agentType?: any;
  vehicleTypes?: any;
  employmentType?: EmploymentType;
  agentSkills?: any;
  agentAssistant?: any;
  isFavouriteAgentsMode?: boolean
  sortType?: string
  selectedQuickFilterId?: string;
  absenceReasons: AbsenceReasonSettings[];

  private agentsRef: any;
  private servicesRef: any;
  private serviceAreasRef: any;
  private siteId: string;
  public isLoadingCreateShift: boolean;
  private configZoneId: string;
  private shiftActions: any;
  private availabilityActions: any;
  private leaveActions: any;
  public pagenationPages: any;
  public schedules: any;
  public approvalSchedules: any;
  public approvalSchedulesTypes: ScheduleType[] = [ScheduleType.Availability, ScheduleType.Leave];
  public approvalSchedulesTypesOptions: ScheduleType[] = [ScheduleType.Availability, ScheduleType.Leave];
  public serviceAreas: any;
  public agentsSearchTerm: string;
  public pageName: string;
  private breakActions: any;

  private filtersConfig: any;
  private agentTypes: any;
  public branchServiceAreasIds: string[];


  public selectedShift: any;
  public selectedShiftTemplate: any;
  public selectedShiftDate: any;
  public selectedShiftAgent: AgentModel;
  public isEditShiftEnabled: boolean;
  public highlightedShifts: any;
  public loading: boolean = false;
  private pushesTimeoutRef: any;
  private maxUserIdleTimeMinutes: number;
  private isSuperOwner: boolean;

  public paginationData: AgentsPaginationDataModel;
  public paginationPages: number[];
  public isTooltipsEnabled: boolean = true;
  public isShowLeaveTable: boolean = false;
  public selectedTab: string; // SERVICES/MAP
  public selectedServices: any[] = [];
  public favouriteAgentIds: string[];


  constructor(private agentConstants, private $filter, private commonsService: CommonsService,
              private scheduleService: ScheduleService, private bringozLoaderService: BringozLoaderService,
              private $timeout: ITimeoutService, private $mdSelect, private leanPlanningConstants,
              private scheduleDialogService: ScheduleDialogService, private confirmDialogService: ConfirmDialogService, private commonsDialogService: CommonsDialogService,
              private deliveriesDialogService: DeliveriesDialogService, private TimelineService, private quickFilterContextService: QuickFilterContextService,
              private leanPlanningService: LeanPlanningService, private leanPlanningAlertsService: LeanPlanningAlertsService, private $delivery,
              private $serviceArea, private $log, private $q: IQService, private moment, private dateRangeTimeFiltersService: DateRangeTimeFiltersService,
              private servicesService: ServicesService, private agentsContextService: AgentsContextService, private $interval: IIntervalService,
              private serviceAreasService: ServiceAreasService, private IAMPermissions: IAMPermissionsService,
              private $agents: $agentsFactory, private agentsService: AgentsService, private splitService, private $state,
              private analyticsService: AnalyticsService, private viewFilterSettingsService: ViewFilterSettingsService) {
    this.pageName = this.$state.current.name;
    this.agentsRef = this.$agents();
    this.servicesRef = this.$delivery();
    this.serviceAreasRef = this.$serviceArea();
    this.configZoneId = this.splitService.getTimeZone();
    this.maxUserIdleTimeMinutes = this.splitService.maxUserIdleTimeMinutes();
    this.isSuperOwner = this.IAMPermissions.hasRole('super.owner');

    this.shiftActions = [
      {key: 'EDIT', name: 'Edit shift'},
      {key: 'EDIT_BREAKS', name: 'Edit shift break', nameMany: 'Edit shifts break'},
      {key: 'EDIT_NOTES', name: 'Edit shift notes', nameMany: 'Edit shifts notes'},
      {key: 'DELETE', name: 'Delete shift', nameMany: 'Delete shifts'}
    ];

    this.availabilityActions = [
      {key: 'EDIT', name: 'Edit Availability'},
      {key: 'DELETE', name: 'Delete shift', nameMany: 'Delete shifts'}
    ];

    this.leaveActions = [
      {key: 'EDIT', name: 'Edit Leave'},
      {key: 'DELETE', name: 'Delete shift', nameMany: 'Delete shifts'}
    ];

    this.breakActions = [
      {key: 'EDIT', name: 'Edit Leave', icon: 'edit'},
      {key: 'DELETE', name: 'Delete shift', nameMany: 'Delete shifts'}
    ];
  }

  $onInit() {
    const range = this.from && this.to ? {
      dateStart: this.from,
      dateEnd: this.to
    } : this.dateRangeTimeFiltersService.today();

    this.agentTypes = this.agentConstants.types;
    this.siteId = this.splitService.getSiteId();
    this.isLoadingCreateShift = false;
    this.favouriteAgentIds = angular.copy(this.agentsContextService.getFavouriteAgentIds());

    this.filtersConfig = {
      range: range,
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      selectedDateExtraDays: this.moment(range.dateEnd).diff(this.moment(range.dateStart), 'days'),
      queryString: undefined,
      includeFilters: [
        SiteFiltersType.branchIds,
        SiteFiltersType.serviceAreaIds,
        SiteFiltersType.teamIds,
        SiteFiltersType.agentIds,
        SiteFiltersType.vehicleTypes,
        SiteFiltersType.agentType,
        SiteFiltersType.employmentType,
        SiteFiltersType.agentStatus,
        SiteFiltersType.agentAssistant
      ],
      bringozFilters: {
        [SiteFiltersType.branchIds]: this.branchIds,
        [SiteFiltersType.serviceAreaIds]: this.serviceAreaIds || [],
        [SiteFiltersType.teamIds]: this.teamIds || [],
        [SiteFiltersType.agentIds]: this.agentIds || [],
        [SiteFiltersType.employmentType]: this.employmentType,
        [SiteFiltersType.agentType]: this.agentType,
        [SiteFiltersType.vehicleTypes]: this.vehicleTypes || [],
        [SiteFiltersType.agentStatus]: this.agentsGroup,
        [SiteFiltersType.agentAssistant]: this.agentAssistant
      }
    }

    if (!this.size) {
      this.size = 50;
    }
    if (!this.page) {
      this.page = 0;
    }
    if (!this.sortType) {
      this.sortType = 'fullName,asc';
    }

    this.schedules = [];
    this.approvalSchedules = [];
    this.highlightedShifts = [];

    if (this.branchIds) {
      this._getBranchServiceAreas();
    }

    this._initAgents();

    // Agents Create/Change/Remove Event Listener
    this.agentsRef.$subscribeToChannelEvents((updatedAgents, action) => {
      if (action === 'changed') {
        const agentsToUpdate = [];

        updatedAgents.forEach((a) => {
          const agentIndexToUpdate = _.findIndex(this.paginationData.content, (displayedAgent) => {
            return displayedAgent.id === a.id;
          })

          if (agentIndexToUpdate > -1) {
            agentsToUpdate.push(a);
          }
        })

        // Update Agents
        if (agentsToUpdate.length) {
          this.paginationData.content = _.uniqBy(_.concat(agentsToUpdate, this.paginationData.content), 'id');
        }

      }

    });

    // Bind User Event Listeners
    this.commonsService.bindUserEvents((event) => {
      if (!!this.pushesTimeoutRef) {
        this._initPushesTimer();
      }
    })
    this._initPushesTimer();

  }

  $onChanges(changes) {
    if (changes.from && !changes.from.isFirstChange ||
      changes.to && !changes.to.isFirstChange) {
      this.filtersConfig.range = {dateStart: this.from, dateEnd: this.to};
    }
  };

  $onDestroy() {
    this.agentsRef.$destroyChannel();
    this._destroyPushesTimer();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {

    if (!_.isEqual(this.filtersConfig.bringozFilters.branchIds, filters.branchIds)) {
      this.favouriteAgentIds = [];
      this._getBranchServiceAreas();
    }

    this.filtersConfig.bringozFilters = filters;
    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);

    this._initAgents();
    this._setStateParams();
  }

  onDateChange(selectedDate) {
    this.filtersConfig.range = {
      dateStart: this.moment(selectedDate).startOf('day').valueOf(),
      dateEnd: this.moment(selectedDate).add(this.filtersConfig.selectedDateExtraDays, 'day').endOf('day').valueOf()
    };
    this._setViewData();
    this._setStateParams();
  }

  onDateFocus(selectedDate) {
    this.filtersConfig.selectedDateExtraDays = 0;
    this.onDateChange(selectedDate);
  }

  onDatesBrowse(isNext) {
    const date = isNext ?
      this.moment(this.filtersConfig.range.dateStart).add(1, 'day').valueOf() :
      this.moment(this.filtersConfig.range.dateStart).subtract(1, 'day').valueOf()

    this.onDateChange(date);
  }

  onSetExtraDays(extraDays) {
    this.filtersConfig.selectedDateExtraDays = extraDays;
    this.onDateChange(this.filtersConfig.range.dateStart);
  }

  onTabSelection(selectedTab) {
    this.selectedTab = selectedTab !== this.selectedTab ? selectedTab : undefined;
    this.onShiftUnSelect();
  }

  onPaginationBrowse(isNext) {
    this.page = isNext ? this.page + 1 : this.page - 1;

    this._setStateParams();
    this._initAgents();
  }

  onPaginationChange(page) {
    this.page = page;

    this._setStateParams();
    this._initAgents();
  }

  onPageSizeChange(size) {
    this.size = size;
    this.page = 0;

    this._setStateParams();
    this._initAgents();
  }

  onQueryChange(queryString) {
    this.filtersConfig.queryString = queryString;
    this.page = 0;

    this._initAgents();
  }

  rangeChanged(range) {
    this.filtersConfig.range = range;
    this._setViewData();
    this._setStateParams();
  }

  onToggleIsTooltipsEnabled(isTooltipsEnabled) {
    this.isTooltipsEnabled = !isTooltipsEnabled;
  }

  onToggleLeaveTable() {
    this.isShowLeaveTable = !this.isShowLeaveTable;
  }

  saveAgentsSelect() {
    this.$mdSelect.hide();
  }

  onHighlightedItemsChange(highlightedSchedules) {
    this.highlightedShifts = highlightedSchedules;
  }

  onChatClick(agentId) {

  }

  onAgentColorSelect(agent: AgentModel, color?: string) {
    this.commonsDialogService.selectColor(agent.displayColor || color)
      .then((selectedColor) => {
        const agentCopy = angular.copy(agent);
        agentCopy.displayColor = selectedColor;

        this._updateAgent(agentCopy);
      })
  }

  onToggleIsFavouriteAgentsMode() {
    this.isFavouriteAgentsMode = !this.isFavouriteAgentsMode;
    this.page = 0;
    this._initAgents();
    this._setStateParams();
  }

  onToggleFavouriteAgent(agentId: string) {
    let favouriteAgentIdsCopy = angular.copy(this.favouriteAgentIds);
    const currentIndex = favouriteAgentIdsCopy.findIndex((id: string) => {
      return id === agentId;
    })

    if (currentIndex >= 0) {
      favouriteAgentIdsCopy.splice(currentIndex, 1);
    } else {
      favouriteAgentIdsCopy.push(agentId);
    }

    const isSuccessful = this.agentsContextService.setFavouriteAgentIds(favouriteAgentIdsCopy);
    if (isSuccessful) {
      this.favouriteAgentIds = favouriteAgentIdsCopy;

      if (!!this.isFavouriteAgentsMode) {
        this.paginationData.content = _.filter(this.paginationData.content, (a) => {
          return !!_.includes(this.favouriteAgentIds, a.id)
        })

        if (!this.paginationData.content.length) {
          this.favouriteAgentIds = [];
          this.isFavouriteAgentsMode = false;
          this.page = 0;
          this._initAgents();
          this._setStateParams();
        }

      }
    }

  }

  onResetFavouriteAgents($event) {
    const title = 'Reset Favourites';
    const body = 'Are you sure you want to reset?';

    this.confirmDialogService.confirm(title, body, $event)
      .then(() => {
        this.agentsContextService.setFavouriteAgentIds([]);

        this.favouriteAgentIds = [];
        this.isFavouriteAgentsMode = false;
        this.page = 0;
        this._initAgents();
        this._setStateParams();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onSortTypeChange(sortType) {
    this.sortType = sortType;
    this.page = 0;
    this.paginationData = undefined;
    this._initAgents();
    this._setStateParams();
  }

  private _updateAgent(agent: AgentModel) {
    this.agentsService.updateOne(agent.id, agent)
      .then((updatedAgent) => {
        const agents = angular.copy(this.paginationData.content);
        const agentIndex = agents.findIndex((a) => {
          return a.id === agent.id;
        })

        if (agentIndex > -1) {
          agents.splice(agentIndex, 1, updatedAgent);
          this.paginationData.content = agents;
        }
      })
  }

  onShiftsBulkEditBreaks(highlightedShifts) {
    const highlightedShiftsCopy = angular.copy(highlightedShifts);

    this.scheduleDialogService.bulkEditBreaks(highlightedShiftsCopy)
      .then((extraDataItemsPayload) => {
        this._onUpdateExtraDataItems(extraDataItemsPayload, this.configZoneId);
      })
  }

  onShiftsBulkEditNotes(highlightedShifts) {
    const highlightedShiftsCopy = angular.copy(highlightedShifts);

    this.scheduleDialogService.bulkEditNotes(highlightedShiftsCopy)
      .then((extraDataItemsPayload) => {
        this._onUpdateExtraDataItems(extraDataItemsPayload, this.configZoneId);
      })
  }

  onToggleHighlightSchedule(id, shift, date, agent) {
    const shiftIndex = _.findIndex(this.highlightedShifts, (highlightedShiftData: any) => {
      return highlightedShiftData.id === id;
    })

    if (shiftIndex > -1) {
      const highlightedShiftsCopy = angular.copy(this.highlightedShifts);
      highlightedShiftsCopy.splice(shiftIndex, 1);
      this.highlightedShifts = highlightedShiftsCopy;
    } else {
      this.highlightedShifts = this.highlightedShifts.concat({
        id: id,
        schedule: shift,
        date: date,
        agent: agent
      })
    }

  }

  onCreateSchedule(agent, startDate?, endDate?) {
    const userName = agent ? this.$filter('userName')(agent.user) : '';
    const formattedDate = startDate ? this.$filter('bringozFullDate')({notAfter: startDate}, 'notAfter') : '';
    const name = [userName, formattedDate].filter(part => part).join(' ');

    const selectedShift = {
      agentSchedule: {
        name: name || '',
        type: ScheduleType.Availability,
        schedule: {
          startTime: startDate,
          endTime: endDate
        }
      }
    }
    this.onShiftSelect(selectedShift, startDate, agent, true);
  }

  onShiftSelect(shift, date, agent?: AgentModel, isEdit?) {
    this.selectedShift = shift;
    this.selectedShiftDate = date;
    this.selectedShiftAgent = agent;
    this.isEditShiftEnabled = isEdit || false;
    this.selectedShiftTemplate = undefined;

    if (!!shift?.agentSchedule?.templateId && !shift?.agentSchedule?.template && !shift?.agentSchedule?.overridden) {
      this._getShiftTemplate(shift.agentSchedule.templateId, agent.id);
    }
  }

  onShiftUnSelect() {
    this.selectedShift = undefined;
    this.selectedShiftTemplate = undefined;
    this.selectedShiftDate = undefined;
    this.selectedShiftAgent = undefined;
    this.isEditShiftEnabled = false;
  }

  onCreateShift(shift, weekDays) {

    if (!!weekDays) {
      const shifts = _.map(weekDays, (wd) => {
        const shiftCopy = angular.copy(shift);
        shiftCopy.agentSchedule.schedule.byWeekDay = [wd];
        return shiftCopy;
      })
      this._createMultipleSchedule(shifts);
    } else {
      this._createSchedule(shift);
    }
  }

  onUpdateShiftFromTimeline(shift, updateSpecificDay, callback) {
    this.confirmDialogService.confirm('Update Shift', 'Are you sure you want to update shift?')
      .then(() => {
        this.onUpdateShift(shift, updateSpecificDay);
      })
      .catch((error) => {
        callback(null);
      })
  }

  onUpdateShift(shift, updateSpecificDay) {
    const type = (!!updateSpecificDay || _.isUndefined(updateSpecificDay)) ? 'EVENT' : 'FUTURE';
    this._updateOneSchedule(shift, type);
  }

  onEditShift(enabled) {
    this.isEditShiftEnabled = enabled;
  }

  onAddNoteToShift($event, extraDataItem?) {
    this.scheduleDialogService.addNote($event, _.get(extraDataItem, 'internalNote'))
      .then((internalNote) => {
        const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
        const agentId = _.get(this.selectedShift, 'agentId');
        const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

        if (!extraDataItem) {
          extraDataItem = {};
        }

        const extraDataItemCopy = angular.copy(extraDataItem);
        extraDataItemCopy.internalNote = internalNote;
        const scheduleExtraDataPayload = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: this.selectedShiftDate,
          extraData: extraDataItemCopy
        }
        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  onRightClickBreak(schedule, event) {
    this.commonsService.openActionPanel(this.breakActions, event)
      .then((action: any) => {
        if (_.isEqual(action.key, 'EDIT')) {
          this._onUpdateBreak(schedule, event);
        }
        if (_.isEqual(action.key, 'DELETE')) {
          this._onDeleteSchedule(schedule, event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onAddBreakToShift($event, extraDataItem?) {
    var day = this.moment(this.selectedShiftDate).date(),
      month = this.moment(this.selectedShiftDate).month(),
      year = this.moment(this.selectedShiftDate).year();

    const minStartTime = this.moment(this.selectedShift.agentSchedule.schedule.startTime).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    const minEndTime = this.moment(this.selectedShift.agentSchedule.schedule.endTime).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();

    const isRecurring = !!this.selectedShift?.agentSchedule?.templateId && !this.selectedShift.agentSchedule.template && !this.selectedShift.agentSchedule.overridden;
    this.scheduleDialogService.updateShiftBreak($event, undefined, isRecurring, minStartTime, minEndTime)
      .then((payload: {
        break: any,
        type: AgentScheduleExtraDataRequestType,
        repeatFrom?: string,
        repeatTo?: string
      }) => {
        const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
        const agentId = _.get(this.selectedShift, 'agentId');
        const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

        if (!extraDataItem) {
          extraDataItem = {};
        }

        const extraDataItemCopy = angular.copy(extraDataItem);

        if (!extraDataItemCopy.breaks?.length) {
          extraDataItemCopy.breaks = [];
        }

        extraDataItemCopy.breaks.push(payload.break);

        const scheduleExtraDataPayload: AgentScheduleExtraDataRequestModel = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: this.selectedShiftDate,
          extraData: extraDataItemCopy,
          type: payload.type
        }

        if (payload.repeatFrom && payload.repeatTo) {
          scheduleExtraDataPayload.repeatFrom = payload.repeatFrom;
          scheduleExtraDataPayload.repeatTo = payload.repeatTo;
        }


        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  onEditBreakToShift($event, extraDataItem, breakIndex) {
    var day = this.moment(this.selectedShiftDate).date(),
      month = this.moment(this.selectedShiftDate).month(),
      year = this.moment(this.selectedShiftDate).year();

    const minStartTime = this.moment(this.selectedShift.agentSchedule.schedule.startTime).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    const minEndTime = this.moment(this.selectedShift.agentSchedule.schedule.endTime).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    const isRecurring = !!this.selectedShift?.agentSchedule?.templateId && !this.selectedShift.agentSchedule.template && !this.selectedShift.agentSchedule.overridden;
    this.scheduleDialogService.updateShiftBreak($event, extraDataItem.breaks[breakIndex], isRecurring, minStartTime, minEndTime)
      .then((payload: {
        break: any,
        type: AgentScheduleExtraDataRequestType,
        repeatFrom?: string,
        repeatTo?: string
      }) => {
        const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
        const agentId = _.get(this.selectedShift, 'agentId');
        const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');


        const extraDataItemCopy = angular.copy(extraDataItem);

        extraDataItemCopy.breaks[breakIndex] = payload.break;

        const scheduleExtraDataPayload: AgentScheduleExtraDataRequestModel = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: this.selectedShiftDate,
          extraData: extraDataItemCopy,
          type: payload.type,
        }

        if (payload.repeatFrom && payload.repeatTo) {
          scheduleExtraDataPayload.repeatFrom = payload.repeatFrom;
          scheduleExtraDataPayload.repeatTo = payload.repeatTo;
        }

        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  onRemoveNoteFromShift($event, extraDataItem?) {
    const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
    const agentId = _.get(this.selectedShift, 'agentId');
    const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

    const extraDataItemCopy = angular.copy(extraDataItem);
    extraDataItemCopy.internalNote = undefined;
    const scheduleExtraDataPayload = {
      scheduleId: scheduleId,
      agentId: agentId,
      eventDate: this.selectedShiftDate,
      extraData: extraDataItemCopy
    }
    this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
  }

  onRemoveBreakFromShift($event, extraDataItem, breakIndex) {
    let extraDataItemCopy = angular.copy(extraDataItem);
    // if (!extraDataItemCopy) {
    //   extraDataItemCopy = {};
    // } else {
    //   _.unset(extraDataItemCopy, 'breaks');
    // }

    extraDataItemCopy.breaks.splice(breakIndex, 1);

    const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
    const agentId = _.get(this.selectedShift, 'agentId');
    const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

    const scheduleExtraDataPayload = {
      scheduleId: scheduleId,
      agentId: agentId,
      eventDate: this.selectedShiftDate,
      extraData: extraDataItemCopy
    }
    this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
  }

  onMoveGroup(agentId, index) {
    if (this.isFavouriteAgentsMode) {
      let favouriteAgentIdsCopy = angular.copy(this.favouriteAgentIds);
      favouriteAgentIdsCopy = favouriteAgentIdsCopy.filter((id) => {
        return id !== agentId;
      })
      favouriteAgentIdsCopy.splice(index, 0, agentId);
      this.favouriteAgentIds = favouriteAgentIdsCopy;
      this.agentsContextService.setFavouriteAgentIds(favouriteAgentIdsCopy);
    }
  }

  onRightClickShift(shiftItem, $event) {
    let actions = angular.copy(this.shiftActions);

    if (this.highlightedShifts.length > 1) {
      actions = actions.filter(a => {
        return a.key !== 'EDIT' && a.key !== 'DELETE';
      })
      _.forEach(actions, (a) => {
        a.name = a.nameMany
      })
    }

    const header = (this.highlightedShifts?.length > 1) ? `${this.highlightedShifts.length} shifts selected` : undefined;
    this.commonsService.openActionPanel(actions, $event, header)
      .then((action: any) => {
        if (_.isEqual(action.key, 'EDIT')) {
          const selectedShift = angular.copy(shiftItem.ref);
          const selectedShiftDate = this.moment(shiftItem.start).valueOf();
          const agent = this.paginationData.content.find((a) => {
            return a.id === shiftItem.agentId;
          })

          this.onShiftSelect(selectedShift, selectedShiftDate, agent, true);
        }
        if (_.isEqual(action.key, 'EDIT_BREAKS')) {
          this.onShiftsBulkEditBreaks(this.highlightedShifts);
        }
        if (_.isEqual(action.key, 'EDIT_NOTES')) {
          this.onShiftsBulkEditNotes(this.highlightedShifts);
        }
        if (_.isEqual(action.key, 'DELETE')) {
          this._onDeleteSchedule(shiftItem, $event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onRightClickAvailability(shiftItem, $event) {
    let actions = angular.copy(this.availabilityActions);

    this.commonsService.openActionPanel(actions, $event)
      .then((action: any) => {
        if (_.isEqual(action.key, 'EDIT')) {
          const selectedShift = angular.copy(shiftItem.ref);
          const selectedShiftDate = this.moment(shiftItem.start).valueOf();
          const agent = this.paginationData.content.find((a) => {
            return a.id === shiftItem.agentId;
          })

          this.onShiftSelect(selectedShift, selectedShiftDate, agent, true);
        }
        if (_.isEqual(action.key, 'DELETE')) {
          this._onDeleteSchedule(shiftItem, $event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onRightClickLeave(shiftItem, $event) {
    let actions = angular.copy(this.leaveActions);

    this.commonsService.openActionPanel(actions, $event)
      .then((action: any) => {
        if (_.isEqual(action.key, 'EDIT')) {
          const selectedShift = angular.copy(shiftItem.ref);
          const selectedShiftDate = this.moment(shiftItem.start).valueOf();
          const agent = this.paginationData.content.find((a) => {
            return a.id === shiftItem.agentId;
          })

          this.onShiftSelect(selectedShift, selectedShiftDate, agent, true);
        }
        if (_.isEqual(action.key, 'DELETE')) {
          this._onDeleteSchedule(shiftItem, $event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onSelectedServicesChange(selectedServices) {
    this.selectedServices = selectedServices;
  }

  onApprovalSchedulesTypesChange(approvalSchedulesTypes: ScheduleType[]) {
    this.approvalSchedulesTypes = approvalSchedulesTypes;
    this._setApprovalSchedules(this.schedules, approvalSchedulesTypes);
  }

  onApproveSchedule(shift: any, from: string, to: string) {
    const payload = [
      {id: shift.agentSchedule.id, from: from, to: to}
    ];
    this.scheduleService.approveSchedule(payload)
      .then((approvedSchedules) => {
        const shiftCopy = angular.copy(shift);
        shiftCopy.agentSchedule = approvedSchedules[0];

        const approvalScheduleIndex = this.approvalSchedules.findIndex((s) => {
          return s.id === shift.id;
        })
        this.approvalSchedules[approvalScheduleIndex] = shiftCopy;

        const scheduleIndex = this.schedules.findIndex((s) => {
          return s.id === shift.id;
        })
        const schedulesCopy = angular.copy(this.schedules);
        schedulesCopy[scheduleIndex] = shiftCopy;
        this.schedules = schedulesCopy;
      })
  }

  onRejectSchedule(shift: any) {
    const payload = [shift.agentSchedule.id];
    this.scheduleService.rejectSchedule(payload)
      .then((rejectedSchedules) => {
        const shiftCopy = angular.copy(shift);
        shiftCopy.agentSchedule = rejectedSchedules[0];

        const approvalScheduleIndex = this.approvalSchedules.findIndex((s) => {
          return s.id === shift.id;
        })
        this.approvalSchedules[approvalScheduleIndex] = shiftCopy;

        const scheduleIndex = this.schedules.findIndex((s) => {
          return s.id === shift.id;
        })
        const schedulesCopy = angular.copy(this.schedules);
        schedulesCopy[scheduleIndex] = shiftCopy;
        this.schedules = schedulesCopy;
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _setStateParams() {
    this.$state.go('.', {
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      agentsGroup: this.filtersConfig.bringozFilters.agentStatus,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      teamIds: this.filtersConfig.bringozFilters.teamIds,
      isFavouriteAgentsMode: this.isFavouriteAgentsMode,
      sortType: this.sortType,
      serviceAreaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      agentType: this.filtersConfig.bringozFilters.agentType,
      vehicleTypes: this.filtersConfig.bringozFilters.vehicleTypes,
      employmentType: this.filtersConfig.bringozFilters.employmentType,
      agentSkills: this.filtersConfig.bringozFilters.agentSkills,
      agentAssistant: this.filtersConfig.bringozFilters.agentAssistant,
      size: this.size,
      selectedQuickFilterId: this.selectedQuickFilterId,
    }, {notify: false, reload: false});
  }

  private _getBranchServiceAreas() {
    this.serviceAreasService.getAll({serviceTypes: 'Pricing', branchIds: this.branchIds})
      .then((ids) => {
        return this.serviceAreasRef.$asyncValues(ids);
      })
      .then((serviceAreas) => {
        this.branchServiceAreasIds = _.map(serviceAreas, 'id');
      })
  }

  private _initAgents() {
    const agentsGroupRef = this.filtersConfig.bringozFilters.agentStatus;

    // this.paginationData = undefined;
    this.agentsService.getAgentsPagination(this._getAgentsQuery())
      .then((paginationData: AgentsPaginationDataModel) => {
        this.paginationData = paginationData;

        let pages = [];
        _.times(paginationData.totalPages, (i) => {
          pages.push(i);
        });

        this.paginationPages = pages;

        // Sort by favouriteAgentIds list.
        if (!!this.isFavouriteAgentsMode) {
          const agentsMap = _.mapKeys(paginationData.content, (agent) => {
            return agent.id;
          });
          this.paginationData.content = _.map(this.favouriteAgentIds, (id) => {
            return agentsMap[id];
          })
        }

        this._setViewData();
      })
  }


  private _createSchedule(schedule) {
    if (schedule && !this.isLoadingCreateShift) {

      this.isLoadingCreateShift = true;

      const agentSchedule = angular.copy(schedule.agentSchedule);
      agentSchedule.schedule.zoneIdName = this.splitService.getTimeZone();
      agentSchedule.schedule.interval = agentSchedule.schedule.interval || 1;
      this.scheduleService.createManyByAgentId([agentSchedule], this.selectedShiftAgent.id)
        .then((createdSchedule) => {
          this.onShiftUnSelect();
          this._refreshSchedules();
        })
        .catch((error) => {
          this.scheduleDialogService.handleConflictError(error, this.selectedShiftAgent.id, [agentSchedule])
            .then((created) => {
              if (created) {
                this.onShiftUnSelect();
                this._refreshSchedules();
              }
            });
        })
        .finally(() => {
          this.isLoadingCreateShift = false;
        })
    }
  }

  private _createMultipleSchedule(shifts) {
    if (shifts.length) {

      const agentSchedulesList = [];

      _.forEach(shifts, (s) => {
        const agentSchedule = angular.copy(s.agentSchedule);
        agentSchedule.schedule.zoneIdName = this.splitService.getTimeZone();
        agentSchedule.schedule.interval = agentSchedule.schedule.interval || 1;
        agentSchedulesList.push(agentSchedule);
      })

      this.scheduleService.createManyByAgentId(agentSchedulesList, this.selectedShiftAgent.id)
        .then((createdSchedule) => {
          this.onShiftUnSelect();
          this._refreshSchedules();
        })
        .catch((error) => {
          this.scheduleDialogService.handleConflictError(error, this.selectedShiftAgent.id, agentSchedulesList)
            .then((created) => {
              if (created) {
                this.onShiftUnSelect();
                this._refreshSchedules();
              }
            });
        })
    }
  }

  private _updateOneSchedule(shift, type) {
    this.scheduleService.updateOneByAgentId(shift.agentSchedule, shift.agentSchedule.id, shift.agentId, type, shift.agentSchedule.schedule.startTime)
      .then((updatedSchedule) => {
        // const shiftRef = _.find(this.schedules, (s) => {
        //   return s.id === this.selectedShift.id;
        // })
        //
        // shiftRef.agentSchedule = updatedSchedule;
        // this.schedules = angular.copy(this.schedules);
        // this.selectedShift.agentSchedule = updatedSchedule;
        // this.isEditShiftEnabled = false;
        this.onShiftUnSelect();
        this._refreshSchedules();
      })
      .catch((error) => {
        this.scheduleDialogService.handleConflictError(error, shift.agentId);
      })
  }

  private _onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId) {
    this.scheduleService.updateScheduleExtraData([scheduleExtraDataPayload], zoneId)
      .then((updatedExtraDataItems) => {

        const shiftRef = _.find(this.schedules, (s) => {
          return s.id === this.selectedShift.id;
        })

        if (!shiftRef.scheduleExtraData) {
          shiftRef.scheduleExtraData = [];
        }

        shiftRef.scheduleExtraData = _.uniqBy(_.concat(updatedExtraDataItems, shiftRef.scheduleExtraData), 'id');
        shiftRef.agentSchedule.updatedAt = this.moment().valueOf();
        this.schedules = angular.copy(this.schedules);

        this.selectedShift = angular.copy(shiftRef);
        this.isEditShiftEnabled = false;
      })
  }

  private _onUpdateExtraDataItems(scheduleExtraDataPayload, zoneId) {
    this.scheduleService.updateScheduleExtraData(scheduleExtraDataPayload, zoneId)
      .then((updatedExtraDataItems) => {
        this.highlightedShifts = [];
        this._refreshSchedules();
      })
  }

  // private _onUpdateNote(note, scheduleId, agentId, instanceDate, zoneId) {
  //   this.scheduleService.updateScheduleExtraData(note, scheduleId, agentId, instanceDate, zoneId)
  //     .then((updatedExtraDataObject) => {
  //       const shiftRef = _.find(this.schedules, (s) => {
  //         return s.id === this.selectedShift.id;
  //       })
  //
  //       if (!shiftRef.scheduleExtraData) {
  //         shiftRef.scheduleExtraData = [];
  //       }
  //
  //       shiftRef.scheduleExtraData = _.uniqBy(_.concat([updatedExtraDataObject], shiftRef.scheduleExtraData), 'id');
  //       shiftRef.agentSchedule.updatedAt = this.moment().valueOf();
  //       this.schedules = angular.copy(this.schedules);
  //
  //       this.selectedShift = angular.copy(shiftRef);
  //       this.isEditShiftEnabled = false;
  //     })
  // }

  private _setViewData() {
    this.schedules = [];
    this.approvalSchedules = [];
    this.serviceAreas = [];

    const displayedAgentsIds = _.map(this.paginationData.content, 'id');

    if (displayedAgentsIds && displayedAgentsIds.length) {
      const schedules = this._getSchedules(displayedAgentsIds, this.filtersConfig.range.dateStart, this.filtersConfig.range.dateEnd, this.filtersConfig.bringozFilters.serviceAreaIds),
        serviceAreas = this._getServiceAreasByAgents(this.paginationData.content)

      this.$q.all([schedules, serviceAreas])
        .then((response: any) => {
          this._setSchedules(response[0]);
          this.serviceAreas = response[1];
        })
    }
  }

  private _getAgentsQuery() {
    const group = this.filtersConfig.bringozFilters.agentStatus;
    const size = !!this.isFavouriteAgentsMode ?
      this.favouriteAgentIds.length :
      this.size;

    const queryPayload: AgentsPaginationQueryModel = {
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentTypes: this.filtersConfig.bringozFilters.agentType,
      vehicleTypes: this.filtersConfig.bringozFilters.vehicleTypes,
      // depotIds?: string[];
      // accountIds?: string[];
      group: undefined,
      status: this.filtersConfig.bringozFilters.agentStatus,
      type: this.filtersConfig.bringozFilters.employmentType,
      activeAssistant: this.filtersConfig.bringozFilters.agentAssistant,
      // noArea?: boolean;
      areaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      skill: this.filtersConfig.bringozFilters.agentSkills,
      query: this.filtersConfig.queryString,
      ids: this.isFavouriteAgentsMode ? this.favouriteAgentIds :
        (this.filtersConfig.bringozFilters.agentIds.length ? this.filtersConfig.bringozFilters.agentIds : undefined),
      teamIds: this.filtersConfig.bringozFilters.teamIds,
      tags: this.filtersConfig.bringozFilters.tags,
      active: true,
      // registrationStatusActive?: boolean; // default true
      page: this.page, // default 0
      size: size, // default 20
      sort: [this.sortType]


      // agentTypes: this.filtersConfig.bringozFilters.agentType ?
      //   [this.filtersConfig.bringozFilters.agentType] : undefined
    };

    if (!!group) {
      if (_.isEqual(group, 'Active')) {
        queryPayload.group = group;
        // queryPayload.status = 'OnDuty';
      }
      if (_.isEqual(group, 'OffDuty')) {
        queryPayload.status = group;
      }
    }

    return queryPayload;
  }

  private _refreshSchedules() {
    const displayedAgentsIds = _.map(this.paginationData.content, 'id');
    this._getSchedules(displayedAgentsIds, this.filtersConfig.range.dateStart, this.filtersConfig.range.dateEnd, this.filtersConfig.bringozFilters.serviceAreaIds)
      .then((schedules) => {
        this._setSchedules(schedules);
      });
  }

  private _getSchedules(displayedAgentsIds, from, to, serviceAreaIds) {
    const scheduleTypes = [ScheduleType.Shift, ScheduleType.Availability, ScheduleType.Leave];
    return this.scheduleService.getByAgentIds(displayedAgentsIds, from, to, scheduleTypes, serviceAreaIds, true);
  }

  private _getServiceAreasByAgents(agents) {
    const priorityServiceAreasIds = _.chain(agents)
      .flatMap('agentPreferencesReference.priorityServiceAreas')
      .compact()
      .uniq()
      .value()

    return priorityServiceAreasIds.length ? this.serviceAreasService.getAreasByIds(priorityServiceAreasIds) : this.$q.when([]);
  }

  private _setSchedules(schedules) {
    this.schedules = schedules;
    this._setApprovalSchedules(schedules, this.approvalSchedulesTypes);
  }

  private _setApprovalSchedules(schedules, types: ScheduleType[]) {
    this.approvalSchedules = schedules.filter((s) => {
      return _.includes(types, s.agentSchedule.type);
    });
  }

  private _onDeleteSchedule(shiftItem, $event) {
    var eventInstanceDate;
    var changeType;
    const isRecurring = !!shiftItem?.ref?.agentSchedule.templateId && !shiftItem?.ref?.agentSchedule.overridden;

    var functionRef = !!isRecurring ?
      this.scheduleDialogService.selectChangeType($event, 'SCHEDULE_DELETE_INFO') :
      this.confirmDialogService.confirm('Delete shift', 'SCHEDULE_DELETE_INFO');

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        changeType = selectedChangeType || 'EVENT';

        if (changeType === 'EVENT' || changeType === 'FUTURE') {
          eventInstanceDate = shiftItem.start.valueOf();
        }

        this._deleteSchedule(shiftItem.ref.agentSchedule.id, shiftItem.ref.agentId, changeType, eventInstanceDate);
        // _updateOneSchedule(editedSchedule, changeType, eventInstanceDate);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      });
  }

  private _deleteSchedule(scheduleId, agentId, type, eventInstanceDate) {
    this.scheduleService.deleteOneByAgentId(scheduleId, agentId, type, eventInstanceDate)
      .then((deletedShift) => {
        this._refreshSchedules();
      })
  }

  private _getShiftTemplate(templateId: string, agentId: string) {
    this.scheduleService.getOneByAgentId(templateId, agentId)
      .then((template) => {
        if (!!this.selectedShift) {
          this.selectedShiftTemplate = template;
        }
      })
  }

  private _onUpdateBreak(schedule, event) {
    const scheduleExtraDataRef = _.get(schedule, 'scheduleExtraData[0]');
    const breakRef = _.get(schedule, 'scheduleExtraData[0].breaks[0]');
    const isRecurring = !!schedule.agentSchedule.templateId && !schedule.agentSchedule.template && !schedule.agentSchedule.overridden;
    this.scheduleDialogService.updateShiftBreak(event, breakRef, isRecurring, schedule.agentSchedule.schedule.startTime, schedule.agentSchedule.schedule.endTime)
      .then((payload: {
        break: any,
        type: AgentScheduleExtraDataRequestType,
        repeatFrom?: string,
        repeatTo?: string
      }) => {
        const scheduleId = _.get(schedule, 'agentSchedule.id');
        const agentId = _.get(schedule, 'agentId');
        const zoneId = _.get(schedule, 'agentSchedule.schedule.timezone');
        const extraDataItem = scheduleExtraDataRef || {};

        const extraDataItemCopy = angular.copy(extraDataItem);

        extraDataItemCopy['breaks'] = [payload.break];

        const scheduleExtraDataPayload: AgentScheduleExtraDataRequestModel = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: schedule.agentSchedule.schedule.startTime,
          extraData: extraDataItemCopy,
          type: payload.type
        }

        if (payload.repeatFrom && payload.repeatTo) {
          scheduleExtraDataPayload.repeatFrom = payload.repeatFrom;
          scheduleExtraDataPayload.repeatTo = payload.repeatTo;
        }

        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  // private _getBranchSchedule(branchId, from, to) {
  //   return this.scheduleService.getByBranchId(from, to, branchId);
  // }

  private _initPushesTimer() {
    this._destroyPushesTimer();

    this.pushesTimeoutRef = this.$timeout(() => {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;

      this.commonsDialogService.stillThereConfirm()
        .then((continueSession) => {
          if (continueSession) {
            this._initPushesTimer();
          }
        })
    }, (this.maxUserIdleTimeMinutes * 60000));
  }

  private _destroyPushesTimer() {
    if (this.pushesTimeoutRef) {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;
    }
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentsShiftManagementViewNew', {
    bindings: {
      agents: '<',
      agentsGroup: '<?',
      from: '<?',
      to: '<?',
      size: '<?',
      page: '<?',
      branchIds: '<?',
      agentIds: '<?',
      teamIds: '<?',
      serviceAreaIds: '<?',
      agentType: '<?',
      vehicleTypes: '<?',
      employmentType: '<?',
      agentSkills: '<?',
      agentAssistant: '<?',
      isFavouriteAgentsMode: '<?',
      sortType: '<?',
      selectedQuickFilterId: '<?',
      absenceReasons: '<?',
    },
    template: require('./agents-shift-management-view-new.html').default,
    controller: AgentsShiftManagementViewNewComponent
  });
